import React, { Component } from "react";
import '../assets/css/question.css';
import '../assets/css/custom.css';
import '../assets/css/new_style.css';
import CheifComplain from './CheifComplain';
import CheifComplainLocation from './CheifComplainLocation';
import Profile from './Profile';
import Questions from "./Questions";
import PatientNarrative from "./PatientNarrative";
import PatientResponse from "./PatientResponse";

import { CONFIG } from '../helpers/Common';
import IdleTimer from 'react-idle-timer'

class Master extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            next:1,
            prev:0,
            profileData:'',
            complainData:'',
            complainLocation:'',
            questionAnswersData: [],
            responseData: '',
            narrativeSummary: '',
            checkedItems: new Map(),
            isNarrativeUpdate: false,
            surgeon_id: '',
            optionInputFields:new Array(),
            showInput:'', allComplains:[]
        };
        this.handleNextPrevSteps        = this.handleNextPrevSteps.bind(this)
        this.setProfileData             = this.setProfileData.bind(this)
        this.setComplainData            = this.setComplainData.bind(this)
        this.setComplainLocationData    = this.setComplainLocationData.bind(this)
        // this.getAllComplains            = this.getAllComplains.bind(this)
        this.setResponseData            = this.setResponseData.bind(this)
        this.setNarrativeSummary        = this.setNarrativeSummary.bind(this)
        this.setAllComplains            = this.setAllComplains.bind(this)
        this.setCheckedItems            = this.setCheckedItems.bind(this)
        this.setIsNarrativeUpdate       = this.setIsNarrativeUpdate.bind(this)
        
        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
    }
    componentWillMount() {

        let patientPrevData = localStorage.getItem('patientProfile');
        if(patientPrevData)
        {
            this.handleNextPrevSteps(2);
        }
        
        
        this.setState({
            surgeon_id: 51,
        });
        
        
    }
    
    //Clear local storage on close and timeout
    _onIdle(e) {
        localStorage.removeItem('data');
        localStorage.removeItem('patientProfile');
        window.location.reload();
    }
    componentDidMount() {
        window.addEventListener("beforeunload", (ev) => {
            ev.preventDefault();
            localStorage.removeItem('data');
            localStorage.removeItem('patientProfile');
            window.location.reload();
        });
    }

    render() {
        return (
            <React.Fragment>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onIdle={this.onIdle}
                    debounce={250}
                    timeout={1000 * 60 * CONFIG.IdleTimeOut} />

                {this.state.next === 1 && 
                    <Profile 
                        setProfileData={this.setProfileData} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                    />
                }
                {this.state.next === 2 && 
                    <CheifComplain 
                        next={this.state.next} 
                        prev={this.state.prev} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        getComplainData={this.state.complainData} 
                        profileData={this.state.profileData} 
                        setComplainLocation={this.setComplainLocationData} 
                        setComplainData={this.setComplainData}
                    />
                }
                {this.state.next === 3 && 
                    <CheifComplainLocation 
                        next={this.state.next} 
                        prev={this.state.prev} 
                        handleNextPrev={this.handleNextPrevSteps}  
                        getComplainData={this.state.complainData} 
                        setComplainLocation={this.setComplainLocationData}
                        getComplainLocationData={this.state.complainLocationData} 
                    />
                }
                {this.state.next === 4 && 
                    <Questions 
                        next={this.state.next} 
                        prev={this.state.prev} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        getComplainData={this.state.complainData}  
                        setQuestionAnswersData={this.setQuestionAnswersData} 
                        setCheckedItems={this.setCheckedItems} 
                        checkedItems={this.state.checkedItems} 
                        questionAnswersData={this.state.questionAnswersData}
                        isNarrativeUpdate={this.state.isNarrativeUpdate}
                        optionInputFields={this.state.optionInputFields}
                        showInput={this.state.showInput}
                        setOptionInputFields={this.setOptionInputFields}
                        setInputField={this.setShowInputField}
                    />
                }
                {this.state.next === 5 && 
                    <PatientNarrative 
                        setNarrativeSummary={this.setNarrativeSummary}
                        setAllComplains={this.setAllComplains}
                        getAllComplains={this.state.allComplains}
                        getProfileData={this.state.profileData} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        getComplainData={this.state.complainData} 
                        getComplainLocationData={this.state.complainLocationData} 
                        setQuestionAnswersData={this.setQuestionAnswersData} 
                        setCheckedItems={this.setCheckedItems} 
                        getQuestionAnswersData={this.state.questionAnswersData} 
                        isNarrativeUpdate={this.state.isNarrativeUpdate} 
                        setIsNarrativeUpdate={this.setIsNarrativeUpdate}
                    />
                }
                {this.state.next === 6 && 
                    <PatientResponse 
                        getNarrativeSummary={this.state.narrativeSummary} 
                        getProfileData={this.state.profileData} 
                        handleNextPrevSteps={this.handleNextPrevSteps} 
                        setResponseData={this.state.setResponseData} 
                        getComplainData={this.state.complainData} 
                        getComplainLocationData={this.state.complainLocationData}
                        isNarrativeUpdate={this.state.isNarrativeUpdate} 
                    />
                }
            </React.Fragment>
        );
    }

    handleNextPrevSteps = (nextStep)=>
    {   
        this.setState({
            next:nextStep,
            prev:nextStep-1,
        });
    }

    setProfileData=(data)=>{
        this.setState({
            profileData:data
        });
    }

    setComplainData=(data)=>{
        this.setState({
            complainData:data
        });
    }
    setNarrativeSummary=(narrativeSummary)=>{
        let profileData = this.state.profileData;
        profileData['narrative_summary'] = narrativeSummary;
        this.setState({
            profileData:profileData,
            //profileData:profileData
        });
        
    }

    setAllComplains=(allComplains)=>{
        this.setState({
            allComplains:[...this.state.allComplains,...allComplains],
            //profileData:profileData
        });

    }

    setComplainLocationData=(data)=>{
        this.setState({
            complainLocationData:data
        });
    }

    setQuestionAnswersData=(data)=>{
        this.setState({
            questionAnswersData:data
        });
    }
    
    setResponseData=(data)=>{
        this.setState({
            responseData:data
        });
    }

    setIsNarrativeUpdate = (data) =>{
        this.setState({
            isNarrativeUpdate:data
        });
    }
    
    setCheckedItems = (checkedItems) =>{
        this.setState({ checkedItems: checkedItems});
    }

    setOptionInputFields = (data) =>{
        this.setState({
            optionInputFields:data
        });
    }

    setShowInputField = (data) =>{
        this.setState({
            showInput:data
        });
    }

}
export default Master;